(() => {
  // untracked/luggex-checkout-extension-review/luggex-checkout-review/extensions/luggex-checkout-benefits/src/studio-rules.json
  var studio_rules_default = {
    schemaVersion: 1,
    sourceVersion: 5,
    sourceHash: "b80a92b852aad091fb56e2ca9f595da7c0a38502b5b59e905c7960dabfb09365",
    sourceUpdatedAt: "2026-10-29T15:25:40.546Z",
    products: [
      {
        productId: "gid://shopify/Product/8282866450587",
        name: "TSA Luggage Locks",
        variantIds: [
          "gid://shopify/ProductVariant/47104018055323",
          "gid://shopify/ProductVariant/47104018088091",
          "gid://shopify/ProductVariant/47104018120859"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8419699622043",
        name: "FX Front-Open Carry-On Set",
        variantIds: [
          "gid://shopify/ProductVariant/46124355780763",
          "gid://shopify/ProductVariant/46124355813531",
          "gid://shopify/ProductVariant/46124355879067"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8419705225371",
        name: "ZX Carry-On 20''",
        variantIds: [
          "gid://shopify/ProductVariant/46124375572635",
          "gid://shopify/ProductVariant/46124375605403",
          "gid://shopify/ProductVariant/46124375638171",
          "gid://shopify/ProductVariant/49238589571227",
          "gid://shopify/ProductVariant/49238589603995",
          "gid://shopify/ProductVariant/49238589636763",
          "gid://shopify/ProductVariant/49516037898395",
          "gid://shopify/ProductVariant/49516037931163"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8428439339163",
        name: "UX Underseat 16\u2033 \xB7 Black",
        variantIds: [
          "gid://shopify/ProductVariant/46154635542683",
          "gid://shopify/ProductVariant/47092408746139"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8445418700955",
        name: "All-Aluminum Carry-On",
        variantIds: [
          "gid://shopify/ProductVariant/46212293656731"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8452748968091",
        name: "ZX Long-Trip Set (20'' + 28'')",
        variantIds: [
          "gid://shopify/ProductVariant/46234627342491",
          "gid://shopify/ProductVariant/46234627375259",
          "gid://shopify/ProductVariant/47093226995867",
          "gid://shopify/ProductVariant/49687888593051",
          "gid://shopify/ProductVariant/49744667443355"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 2
        }
      },
      {
        productId: "gid://shopify/Product/8452760567963",
        name: "Expandable Essential Set \xB7 20\uFF0B24\uFF0B28\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/46234646216859",
          "gid://shopify/ProductVariant/46234646249627",
          "gid://shopify/ProductVariant/47799329423515"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8464929063067",
        name: "ZX Check-In 28''",
        variantIds: [
          "gid://shopify/ProductVariant/46287775301787",
          "gid://shopify/ProductVariant/46290238800027",
          "gid://shopify/ProductVariant/46290238832795",
          "gid://shopify/ProductVariant/49686478323867"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8464937484443",
        name: "ZX Check-In 24''",
        variantIds: [
          "gid://shopify/ProductVariant/46287796338843",
          "gid://shopify/ProductVariant/46287796404379",
          "gid://shopify/ProductVariant/47209387524251"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8465057775771",
        name: "Expandable Check-In 28\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/46287977250971",
          "gid://shopify/ProductVariant/46287986917531",
          "gid://shopify/ProductVariant/46373645287579"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8465067344027",
        name: "LUGGEX  Expandable Trunk 28''",
        variantIds: [
          "gid://shopify/ProductVariant/47087997124763"
        ],
        benefitIds: [
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8658934726811",
        name: "ZX Shock-Roll Wheels \xB7 4-Pack",
        variantIds: [
          "gid://shopify/ProductVariant/47177850388635",
          "gid://shopify/ProductVariant/47177850421403"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8689484988571",
        name: "UX Underseat 16\u2033 \xB7 Blue",
        variantIds: [
          "gid://shopify/ProductVariant/47251194609819"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8689500586139",
        name: "UX Underseat 16\u2033 \xB7 Cream White",
        variantIds: [
          "gid://shopify/ProductVariant/47251245138075"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8689522114715",
        name: "UX Underseat 16\u2033 \xB7 Grey Pink",
        variantIds: [
          "gid://shopify/ProductVariant/47251345047707"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8689732681883",
        name: "ZX Replacement TSA Lock \xB7 2-Pack",
        variantIds: [
          "gid://shopify/ProductVariant/47251966722203"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8695323492507",
        name: 'FX Expandable Top-Open Check-In 28"',
        variantIds: [
          "gid://shopify/ProductVariant/47277597819035",
          "gid://shopify/ProductVariant/47277597851803",
          "gid://shopify/ProductVariant/47277597884571"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8797766975643",
        name: "Enhance Set \xB7 20\uFF0F30\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/47634794643611"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8806530318491",
        name: "Laptop Sleeve \xB7 13\u201314\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/47665875452059",
          "gid://shopify/ProductVariant/47665875484827",
          "gid://shopify/ProductVariant/47665875517595",
          "gid://shopify/ProductVariant/47665875550363"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8807524958363",
        name: "Luggage Straps \xB7 2-Pack",
        variantIds: [
          "gid://shopify/ProductVariant/47668595949723",
          "gid://shopify/ProductVariant/47668595982491",
          "gid://shopify/ProductVariant/47668596015259",
          "gid://shopify/ProductVariant/49786050117787"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8814753317019",
        name: "Laptop Shoulder Bag \xB7 LTX02",
        variantIds: [
          "gid://shopify/ProductVariant/47683356033179",
          "gid://shopify/ProductVariant/47683356065947",
          "gid://shopify/ProductVariant/47683356131483",
          "gid://shopify/ProductVariant/47683356164251",
          "gid://shopify/ProductVariant/47683356229787",
          "gid://shopify/ProductVariant/47683356262555",
          "gid://shopify/ProductVariant/47683356295323",
          "gid://shopify/ProductVariant/47683356328091",
          "gid://shopify/ProductVariant/47683356360859"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8845869023387",
        name: "LUGGEX Expandable Trunk 30''",
        variantIds: [
          "gid://shopify/ProductVariant/47791169044635",
          "gid://shopify/ProductVariant/49671088537755"
        ],
        benefitIds: [
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8847344402587",
        name: "Laptop Sleeve with Strap \xB7 15\u201316\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/47800563400859",
          "gid://shopify/ProductVariant/47800563433627",
          "gid://shopify/ProductVariant/47800563466395",
          "gid://shopify/ProductVariant/47800563499163",
          "gid://shopify/ProductVariant/47800563531931",
          "gid://shopify/ProductVariant/47800563564699",
          "gid://shopify/ProductVariant/47800563597467",
          "gid://shopify/ProductVariant/47800563630235",
          "gid://shopify/ProductVariant/47800563663003"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8847345975451",
        name: "Laptop Sleeve \xB7 15\u201316\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/47800567627931",
          "gid://shopify/ProductVariant/47800567660699",
          "gid://shopify/ProductVariant/47800567693467",
          "gid://shopify/ProductVariant/47800567726235"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8850881544347",
        name: "Packing Cubes \xB7 4-Pack",
        variantIds: [
          "gid://shopify/ProductVariant/47817837641883"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8851000197275",
        name: "Crossbody Organizer Bag",
        variantIds: [
          "gid://shopify/ProductVariant/47818439950491",
          "gid://shopify/ProductVariant/47818439983259"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8855114580123",
        name: 'ZX Trunk 30"',
        variantIds: [
          "gid://shopify/ProductVariant/47871427281051",
          "gid://shopify/ProductVariant/48863948472475",
          "gid://shopify/ProductVariant/49515177083035"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8856283807899",
        name: "FX Top-Open Carry-On 20''",
        variantIds: [
          "gid://shopify/ProductVariant/47839231475867",
          "gid://shopify/ProductVariant/47839231508635",
          "gid://shopify/ProductVariant/48524161613979"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8856283906203",
        name: "FX Top-Open Check-In 26''",
        variantIds: [
          "gid://shopify/ProductVariant/47839231672475"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8872816115867",
        name: 'ZX Bigger Carry-On 21"',
        variantIds: [
          "gid://shopify/ProductVariant/47913519480987",
          "gid://shopify/ProductVariant/47913519513755"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8888453562523",
        name: "ZX Shock-Roll Pro Wheels",
        variantIds: [
          "gid://shopify/ProductVariant/47970925019291",
          "gid://shopify/ProductVariant/47970931277979",
          "gid://shopify/ProductVariant/47970931310747",
          "gid://shopify/ProductVariant/47970931376283",
          "gid://shopify/ProductVariant/47984069148827"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8917662400667",
        name: "Laptop Tote \xB7 15.6\u2033",
        variantIds: [
          "gid://shopify/ProductVariant/48063653642395",
          "gid://shopify/ProductVariant/48063653675163"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8917664104603",
        name: "Sport Duffel \xB7 40L",
        variantIds: [
          "gid://shopify/ProductVariant/48063667568795",
          "gid://shopify/ProductVariant/48063667601563"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8928193183899",
        name: "FX Travel Set (20'' + 26'')",
        variantIds: [
          "gid://shopify/ProductVariant/49465248678043"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8930741682331",
        name: "Luggage Weight Scale",
        variantIds: [
          "gid://shopify/ProductVariant/48109036929179",
          "gid://shopify/ProductVariant/48109036961947"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8930776481947",
        name: "UX Soft Underseat 16\u2033 \xB7 Black",
        variantIds: [
          "gid://shopify/ProductVariant/48109193265307",
          "gid://shopify/ProductVariant/48109193298075"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8930831696027",
        name: "UX Soft Underseat 16\u2033 \xB7 Beige",
        variantIds: [
          "gid://shopify/ProductVariant/48109373980827",
          "gid://shopify/ProductVariant/48109374013595"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8931908354203",
        name: "HUP Pro Bigger Carry-On",
        variantIds: [
          "gid://shopify/ProductVariant/48112412098715",
          "gid://shopify/ProductVariant/48112412131483"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/8936794128539",
        name: "ZX Pro All-in-One 21''",
        variantIds: [
          "gid://shopify/ProductVariant/48123788886171",
          "gid://shopify/ProductVariant/48123788918939",
          "gid://shopify/ProductVariant/49320812871835",
          "gid://shopify/ProductVariant/49320812904603"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/8991191531675",
        name: "Cosmetic Bags",
        variantIds: [
          "gid://shopify/ProductVariant/48328245018779"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9016235393179",
        name: "Leather Luggage Tag",
        variantIds: [
          "gid://shopify/ProductVariant/48443579957403",
          "gid://shopify/ProductVariant/48443579990171",
          "gid://shopify/ProductVariant/48443580022939"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9077994455195",
        name: "ZX Check-In 30'' + Duffel Bag",
        variantIds: [
          "gid://shopify/ProductVariant/48667131052187"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/9080778915995",
        name: "ZX Travel Set\uFF0820'' / 24'')",
        variantIds: [
          "gid://shopify/ProductVariant/48681106079899",
          "gid://shopify/ProductVariant/48681106112667",
          "gid://shopify/ProductVariant/48681106145435"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 2
        }
      },
      {
        productId: "gid://shopify/Product/9178342228123",
        name: "ZX Family Set (20'' + 24'' + 28'')",
        variantIds: [
          "gid://shopify/ProductVariant/49035427578011",
          "gid://shopify/ProductVariant/49035427610779",
          "gid://shopify/ProductVariant/49035427643547"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 3,
          divider: 3
        }
      },
      {
        productId: "gid://shopify/Product/9196521586843",
        name: "Packing Cubes \xB7 6-Pack",
        variantIds: [
          "gid://shopify/ProductVariant/49081649397915"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9221399937179",
        name: "ZX Check-In 26''",
        variantIds: [
          "gid://shopify/ProductVariant/49235654443163"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/9227044651163",
        name: "ZX Check-In 32'' Trunk",
        variantIds: [
          "gid://shopify/ProductVariant/49235883983003"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/9244912418971",
        name: "FX Top-Open Bigger Carry-On 21''",
        variantIds: [
          "gid://shopify/ProductVariant/49205995339931"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9253725667483",
        name: "ZX Extended Carry-On 22''",
        variantIds: [
          "gid://shopify/ProductVariant/49236312785051"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/9281340866715",
        name: "ZX Weekend Set (20'' + 26'')",
        variantIds: [
          "gid://shopify/ProductVariant/49312982040731"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 2
        }
      },
      {
        productId: "gid://shopify/Product/9284837703835",
        name: "ZX Business Set\uFF0821'' + 28'')",
        variantIds: [
          "gid://shopify/ProductVariant/49322378657947"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 2
        }
      },
      {
        productId: "gid://shopify/Product/9334988013723",
        name: "ZX Carry-On 19''",
        variantIds: [
          "gid://shopify/ProductVariant/49465096470683"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      },
      {
        productId: "gid://shopify/Product/9347490349211",
        name: "ZX Ultimate Set (21'' + 30'')",
        variantIds: [
          "gid://shopify/ProductVariant/49516994658459"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 2,
          divider: 2
        }
      },
      {
        productId: "gid://shopify/Product/9366561456283",
        name: 'ZX Easy-Access Carry-On 21"',
        variantIds: [
          "gid://shopify/ProductVariant/49593300779163",
          "gid://shopify/ProductVariant/49606851002523",
          "gid://shopify/ProductVariant/49863808647323"
        ],
        benefitIds: [
          "cover",
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9419612717211",
        name: "TSA Approved Keyless Locks 4 Packs",
        variantIds: [
          "gid://shopify/ProductVariant/49809826807963",
          "gid://shopify/ProductVariant/49809826840731",
          "gid://shopify/ProductVariant/49809826873499",
          "gid://shopify/ProductVariant/49809826906267",
          "gid://shopify/ProductVariant/49809826939035",
          "gid://shopify/ProductVariant/49809826971803"
        ],
        benefitIds: [
          "credit",
          "returns",
          "shipping",
          "support",
          "warranty"
        ],
        includedQuantityPerParent: {
          cover: 0,
          divider: 0
        }
      },
      {
        productId: "gid://shopify/Product/9467847868571",
        name: "Renewed ZX \xB7 Final Sale",
        variantIds: [
          "gid://shopify/ProductVariant/49971456999579",
          "gid://shopify/ProductVariant/49971457032347",
          "gid://shopify/ProductVariant/49971457065115",
          "gid://shopify/ProductVariant/49971457097883",
          "gid://shopify/ProductVariant/49971457130651",
          "gid://shopify/ProductVariant/49971457163419",
          "gid://shopify/ProductVariant/49971457196187",
          "gid://shopify/ProductVariant/49971457228955",
          "gid://shopify/ProductVariant/49971457261723"
        ],
        benefitIds: [
          "cover",
          "credit",
          "divider",
          "shipping",
          "support",
          "warranty_1year"
        ],
        includedQuantityPerParent: {
          cover: 1,
          divider: 1
        }
      }
    ],
    assets: {
      cover: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/luggex-cart-benefit-cover-20261027.png",
      divider: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/luggex-cart-benefit-divider-20261027.png",
      returns: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/returns-icon-white.jpg?v=1793174947",
      warranty: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/warranty-icon-white.jpg?v=1793174955",
      shipping: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/shipping-icon-white.jpg?v=1793174964",
      credit: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/20-dollar-gift-card-white.jpg?v=1793174971",
      warranty_1year: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/warranty-icon-white.jpg?v=1793174955"
    },
    reviewedCustomBenefits: {
      "benefit_3514e29d-69e1-4e08-922e-1db8506f323f": {
        runtimeId: "warranty_1year",
        productIds: [
          "gid://shopify/Product/9467847868571"
        ],
        label: "1 \u5E74\u6709\u9650\u8D28\u4FDD\uFF08\u7FFB\u65B0 ZX\uFF09"
      }
    }
  };

  // untracked/luggex-checkout-extension-review/luggex-checkout-review/extensions/luggex-checkout-benefits/src/runtime-normalization.js
  var validQuantity = (q) => Number.isSafeInteger(q) && q > 0;
  function normalizeCheckoutLines(lines) {
    const warnings = [];
    if (!Array.isArray(lines)) return { lines: [], warnings: [{ code: "cart_lines_missing" }] };
    const indexed = /* @__PURE__ */ new Map(), duplicates = /* @__PURE__ */ new Set();
    for (const raw of lines) {
      if (!raw || typeof raw.id !== "string" || !raw.id) {
        warnings.push({ code: "line_identity_missing" });
        continue;
      }
      if (indexed.has(raw.id)) {
        duplicates.add(raw.id);
        continue;
      }
      indexed.set(raw.id, raw);
    }
    const normalized = [];
    for (const [id, raw] of indexed) {
      if (duplicates.has(id)) {
        warnings.push({ code: "duplicate_line_identity", lineId: id });
        continue;
      }
      const parentId = raw.parentRelationship?.parent?.id;
      if (parentId) {
        warnings.push({ code: indexed.has(parentId) ? "bundle_child_counted_by_parent" : "orphan_bundle_child_excluded", lineId: id, parentId });
        continue;
      }
      const productId = raw.merchandise?.product?.id;
      const variantId = raw.merchandise?.id;
      if (!validQuantity(raw.quantity)) {
        warnings.push({ code: "invalid_line_quantity", lineId: id });
        continue;
      }
      if (typeof productId !== "string" || typeof variantId !== "string") {
        warnings.push({ code: "merchandise_identity_missing", lineId: id });
        continue;
      }
      const rawNet = raw.cost?.totalAmount?.amount;
      const netAmount = (typeof rawNet === "number" || typeof rawNet === "string") && String(rawNet).trim() !== "" && Number.isFinite(Number(rawNet)) && Number(rawNet) >= 0 ? Number(rawNet) : null;
      normalized.push({ id, productId, variantId, quantity: raw.quantity, netAmount, hasNativeBundleComponents: Array.isArray(raw.lineComponents) && raw.lineComponents.length > 0 });
    }
    return { lines: normalized, warnings };
  }

  // untracked/luggex-checkout-extension-review/luggex-checkout-review/extensions/luggex-checkout-benefits/src/benefit-rules.js
  var SOURCE_VERSION = studio_rules_default.sourceVersion;
  var SOURCE_HASH = studio_rules_default.sourceHash;
  var REVIEW_ATTRIBUTE = { key: "_luggex_checkout_review", value: "test-7e63f622b7d248e3a6cfd19e55f874ac" };
  var serviceDefinitions = {
    returns: { id: "returns", title: "Returns support", icon: "return", description: "Return eligibility and conditions follow the store\u2019s returns policy.", policyUrl: "https://www.luggex.com/policies/refund-policy" },
    warranty: { id: "warranty", title: "Warranty support", icon: "check-circle", description: "Coverage depends on your product and purchase date. The applicable warranty policy and exclusions apply.", policyUrl: "https://www.luggex.com/pages/warranty-policy" },
    warranty_1year: { id: "warranty_1year", title: "1-year limited warranty (Renewed ZX)", icon: "check-circle", description: "One-year limited warranty for Renewed ZX. Applicable coverage and exclusions follow the Renewed ZX policy.", policyUrl: "https://www.luggex.com/pages/warranty-policy" },
    shipping: { id: "shipping", title: "Shipping service", icon: "truck", description: "Available shipping options, charges and delivery estimates depend on your address and order.", policyUrl: "https://www.luggex.com/policies/shipping-policy" },
    support: { id: "support", title: "Customer support", icon: "question-circle", description: "For product and order questions, visit Customer Support.", policyUrl: "https://www.luggex.com/pages/faq" }
  };
  var includedDefinitions = {
    cover: { id: "cover", title: "Luggage cover", description: "Included in the original packaging of your qualifying suitcase. No separate charge." },
    divider: { id: "divider", title: "Removable privacy divider", description: "Included in the original packaging of your qualifying suitcase. No separate charge." }
  };
  var productIndex = new Map(studio_rules_default.products.map((p) => [p.productId, p]));
  var validQuantity2 = (q) => Number.isSafeInteger(q) && q > 0;
  function isEnabled({ attributes: attributes2, settings, editor }) {
    return editor === true || settings?.review_enabled === true || Array.isArray(attributes2) && attributes2.some((a) => a.key === REVIEW_ATTRIBUTE.key && a.value === REVIEW_ATTRIBUTE.value);
  }
  function evaluateCheckoutBenefits({ lines, attributes: attributes2 = [], settings = {}, editor = false } = {}) {
    const enabled = isEnabled({ attributes: attributes2, settings, editor });
    const result = { enabled, sourceVersion: SOURCE_VERSION, sourceHash: SOURCE_HASH, products: [], includedContents: [], services: [], credit: { eligible: false, title: "$20 off your next order", image: studio_rules_default.assets.credit, description: "Receive $20 off a future order of $100 or more. Valid for 60 days after issue. Cannot be combined with other offers. One offer per qualifying paid order.", amountUsd: 20, minimumNextOrderUsd: 100, validDays: 60, stackable: false, actualIssuanceEnabled: false }, warnings: [], cartWrites: false, independentWarehousePick: false };
    if (!enabled) return result;
    const normalized = normalizeCheckoutLines(lines);
    result.warnings.push(...normalized.warnings);
    const quantities = { cover: 0, divider: 0 };
    const services = /* @__PURE__ */ new Set();
    for (const line of normalized.lines) {
      const product = productIndex.get(line.productId);
      if (!product) {
        result.warnings.push({ code: "product_not_approved_in_studio", lineId: line.id });
        continue;
      }
      if (!product.variantIds.includes(line.variantId)) {
        result.warnings.push({ code: "variant_parent_mismatch", lineId: line.id });
        continue;
      }
      result.products.push({ lineId: line.id, productId: line.productId, variantId: line.variantId, name: product.name, quantity: line.quantity });
      for (const id of product.benefitIds) {
        if (id === "cover" || id === "divider") {
          const perParent = product.includedQuantityPerParent[id];
          const amount = perParent * line.quantity;
          if (!validQuantity2(perParent) || !validQuantity2(amount) || !Number.isSafeInteger(quantities[id] + amount)) {
            result.warnings.push({ code: "invalid_included_quantity", lineId: line.id, benefitId: id });
            continue;
          }
          quantities[id] += amount;
        } else if (id === "credit") {
          if (line.netAmount !== null && line.netAmount > 0) result.credit.eligible = true;
          else result.warnings.push({ code: "credit_requires_positive_qualifying_line_amount", lineId: line.id });
        } else if (serviceDefinitions[id]) services.add(id);
        else result.warnings.push({ code: "benefit_requires_review", lineId: line.id, benefitId: id });
      }
    }
    for (const id of ["cover", "divider"]) if (quantities[id]) result.includedContents.push({ ...includedDefinitions[id], image: studio_rules_default.assets[id], quantity: quantities[id], quantityLabel: quantities[id] > 1 ? `\xD7${quantities[id]}` : null, priceLabel: "Free" });
    result.services = ["returns", "warranty", "warranty_1year", "shipping", "support"].filter((id) => services.has(id) && id !== "support").map((id) => ({ ...serviceDefinitions[id], image: studio_rules_default.assets[id] || null }));
    return result;
  }

  // untracked/luggex-checkout-extension-review/luggex-checkout-review/extensions/luggex-checkout-benefits/src/native-display-map.json
  var native_display_map_default = {
    sourceVersion: 5,
    shopDomain: "83d580-ac.myshopify.com",
    benefits: {
      cover: {
        variantId: "gid://shopify/ProductVariant/49956032282779",
        productId: "gid://shopify/Product/9462202761371",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/luggex-cart-benefit-cover-20261027.png",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      divider: {
        variantId: "gid://shopify/ProductVariant/49956033527963",
        productId: "gid://shopify/Product/9462202859675",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/luggex-cart-benefit-divider-20261027.png",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      credit: {
        variantId: "gid://shopify/ProductVariant/49956453417115",
        productId: "gid://shopify/Product/9462430040219",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/20-dollar-gift-card-white.jpg?v=1793174971",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      returns: {
        variantId: "gid://shopify/ProductVariant/49967030272155",
        productId: "gid://shopify/Product/9466695155867",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/returns-icon-white.jpg?v=1793174947",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      warranty: {
        variantId: "gid://shopify/ProductVariant/49967040331931",
        productId: "gid://shopify/Product/9466697744539",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/warranty-icon-white.jpg?v=1793174955",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      shipping: {
        variantId: "gid://shopify/ProductVariant/49977008947355",
        productId: "gid://shopify/Product/9469541580955",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/shipping-icon-white.jpg?v=1793174964",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      support: {
        variantId: "gid://shopify/ProductVariant/49977018286235",
        productId: "gid://shopify/Product/9469547118747",
        verified: true,
        availableForSale: true,
        imageUrl: "https://cdn.shopify.com/s/files/1/0648/2257/5259/files/customer-support-icon-white_800x800.jpg?v=1793273485",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      },
      warranty_1year: {
        variantId: "gid://shopify/ProductVariant/49982253072539",
        productId: "gid://shopify/Product/9471832785051",
        verified: true,
        availableForSale: true,
        imageUrl: "https://www.luggex.com/cdn/shop/files/warranty-icon-white.jpg?v=1793174955&width=112",
        imageVerified: true,
        price: "0.00",
        requiresShipping: false,
        inventoryTracked: false,
        verification: {
          status: "UNLISTED",
          channel: "Online Store",
          storefrontAffordance: "enabled Add to cart at $0.00",
          requiresShippingEvidence: "Existing verified non-shipping display products; freshly read non-physical configuration for new Shipping/Customer service drafts",
          liveCartAdditionVerified: false
        }
      }
    },
    sourceHash: "b80a92b852aad091fb56e2ca9f595da7c0a38502b5b59e905c7960dabfb09365"
  };

  // untracked/checkout-studio-integration-20261029/native-sync/plan.mjs
  var MANAGED_MARKERS = Object.freeze({ display: "_luggex_benefit_display", benefit: "_luggex_benefit_id", source: "_luggex_benefit_source", inBox: "_luggex_fulfillment_mode" });
  var CREDIT_OFFER_TERMS = Object.freeze({ key: "Offer terms", value: "Next order $100+ USD \xB7 60 days after issue \xB7 Cannot be combined" });
  var PRODUCT = "gid://shopify/Product/";
  var VARIANT = "gid://shopify/ProductVariant/";
  var ORDER = ["cover", "divider", "credit", "returns", "warranty", "warranty_1year", "shipping", "support"];
  var compare = (a, b) => a < b ? -1 : a > b ? 1 : 0;
  var positive = (n) => Number.isSafeInteger(n) && n > 0;
  var hashSource = `studio-v${SOURCE_VERSION}`;
  function gid(value, prefix) {
    if (typeof value === "number") {
      if (!Number.isSafeInteger(value) || value <= 0) return null;
      value = String(value);
    }
    if (typeof value !== "string") return null;
    const raw = value.startsWith(prefix) ? value.slice(prefix.length) : value;
    return /^[1-9]\d*$/.test(raw) ? prefix + raw : null;
  }
  function zeroPrice(value) {
    return typeof value === "number" && value === 0 || typeof value === "string" && /^0+(?:\.0+)?$/.test(value);
  }
  function attributes(raw) {
    const input = Array.isArray(raw) ? raw : raw && typeof raw === "object" ? Object.entries(raw).map(([key, value]) => ({ key, value })) : [];
    return input.filter((a) => a && typeof a.key === "string").map((a) => ({ key: a.key, value: typeof a.value === "string" ? a.value : String(a.value ?? "") }));
  }
  function valueOf(attrs, key) {
    const values = attrs.filter((a) => a.key === key).map((a) => a.value);
    return values.length === 0 ? null : values.every((v) => v === values[0]) ? values[0] : "__CONFLICT__";
  }
  function lineAmount(raw, kind) {
    if (kind === "checkout") return raw.cost?.totalAmount?.amount;
    for (const key of ["final_line_price", "line_price"]) if (raw[key] !== void 0) return raw[key];
    return void 0;
  }
  function normalizeNativeCartLines(input) {
    const list = Array.isArray(input) ? input : Array.isArray(input?.items) ? input.items : null;
    if (!list) return { lines: [], warnings: [{ code: "cart_lines_missing" }], valid: false };
    const lines = [], warnings = [], ids = /* @__PURE__ */ new Set();
    let valid = true;
    for (const raw of list) {
      if (!raw || typeof raw !== "object") {
        warnings.push({ code: "invalid_cart_line" });
        valid = false;
        continue;
      }
      const kind = raw.merchandise ? "checkout" : "ajax";
      const id = kind === "checkout" ? raw.id : raw.key;
      if (typeof id !== "string" || !id) {
        warnings.push({ code: "stable_line_identity_required" });
        valid = false;
        continue;
      }
      if (ids.has(id)) {
        warnings.push({ code: "duplicate_cart_line_identity", lineId: id });
        valid = false;
        continue;
      }
      ids.add(id);
      const productId = gid(kind === "checkout" ? raw.merchandise?.product?.id : raw.product_id, PRODUCT);
      const variantId = gid(kind === "checkout" ? raw.merchandise?.id : raw.variant_id ?? raw.id, VARIANT);
      if (!productId || !variantId || !positive(raw.quantity)) {
        warnings.push({ code: "invalid_cart_line_identity_or_quantity", lineId: id });
        valid = false;
        continue;
      }
      const attrs = attributes(kind === "checkout" ? raw.attributes : raw.properties);
      let totalAmount;
      if (kind === "checkout") totalAmount = raw.cost?.totalAmount;
      else if (raw.final_line_price !== void 0 || raw.line_price !== void 0) {
        const cents = raw.final_line_price ?? raw.line_price;
        if (Number.isSafeInteger(cents) && cents >= 0) totalAmount = { amount: cents / 100, currencyCode: raw.currency ?? input?.currency ?? "USD" };
      }
      const evaluationLine = {
        id,
        quantity: raw.quantity,
        merchandise: { id: variantId, product: { id: productId } },
        attributes: attrs,
        ...totalAmount ? { cost: { totalAmount } } : {},
        lineComponents: raw.lineComponents ?? raw.line_components ?? [],
        parentRelationship: raw.parentRelationship ?? raw.parent_relationship ?? null
      };
      lines.push({ id, kind, productId, variantId, quantity: raw.quantity, attributes: attrs, amount: lineAmount(raw, kind), evaluationLine });
    }
    lines.sort((a, b) => compare(a.id, b.id));
    return { lines, warnings, valid };
  }
  function mappingIndex(mapping) {
    const current = /* @__PURE__ */ new Map(), all = /* @__PURE__ */ new Map(), warnings = [];
    if (!mapping || typeof mapping !== "object" || Array.isArray(mapping)) return { current, all, warnings: [{ code: "managed_variant_mapping_required" }], valid: false };
    for (const [id, raw] of Object.entries(mapping)) {
      if (!ORDER.includes(id)) {
        warnings.push({ code: "unknown_managed_benefit", benefitId: id });
        continue;
      }
      const data = typeof raw === "string" ? { variantId: raw } : raw;
      const variantId = gid(data?.variantId, VARIANT);
      if (!variantId) {
        warnings.push({ code: "managed_variant_identity_invalid", benefitId: id });
        continue;
      }
      const row = { ...data, benefitId: id, variantId, productId: gid(data.productId, PRODUCT) };
      current.set(id, row);
      const list = [variantId, ...Array.isArray(data.retiredVariantIds) ? data.retiredVariantIds : []];
      for (const rawId of list) {
        const v = gid(rawId, VARIANT);
        if (!v || all.has(v)) {
          warnings.push({ code: "managed_variant_mapping_conflict", benefitId: id });
          continue;
        }
        all.set(v, { ...row, retired: v !== variantId });
      }
    }
    return { current, all, warnings, valid: warnings.length === 0 };
  }
  function desiredFrom(result) {
    const desired = /* @__PURE__ */ new Map();
    for (const row of result.includedContents ?? []) {
      if (!["cover", "divider"].includes(row.id) || !positive(row.quantity) || desired.has(row.id)) throw new TypeError("invalid_included_result");
      desired.set(row.id, row.quantity);
    }
    if (result.credit?.eligible === true) desired.set("credit", 1);
    for (const row of result.services ?? []) {
      if (!["returns", "warranty", "warranty_1year", "shipping", "support"].includes(row.id) || desired.has(row.id)) throw new TypeError("invalid_service_result");
      desired.set(row.id, 1);
    }
    return desired;
  }
  function resultSignature(result) {
    return JSON.stringify({ enabled: result.enabled, sourceVersion: result.sourceVersion, sourceHash: result.sourceHash, products: (result.products ?? []).map((p) => [p.lineId, p.productId, p.variantId, p.quantity]).sort((a, b) => compare(a[0], b[0])), included: [...result.includedContents ?? []].map((p) => [p.id, p.quantity]).sort((a, b) => compare(a[0], b[0])), credit: result.credit?.eligible === true, services: [...result.services ?? []].map((s) => s.id).sort(compare) });
  }
  function metadataProblem(row) {
    if (!row || row.verified !== true) return "native_variant_not_verified";
    if (!row.productId) return "native_product_identity_not_verified";
    if (row.availableForSale !== true) return "native_variant_not_sellable";
    if (row.imageVerified !== true || typeof row.imageUrl !== "string" || !/^https:\/\/[^\s]+$/.test(row.imageUrl)) return "native_image_not_verified";
    if (!zeroPrice(row.price)) return "native_variant_not_zero_price";
    if (row.requiresShipping !== false) return "native_variant_shipping_not_disabled";
    if (row.inventoryTracked !== false) return "native_variant_inventory_not_untracked";
    return null;
  }
  function newAttributes(id) {
    return [{ key: MANAGED_MARKERS.display, value: "true" }, { key: MANAGED_MARKERS.benefit, value: id }, { key: MANAGED_MARKERS.source, value: hashSource }, ...["cover", "divider"].includes(id) ? [{ key: MANAGED_MARKERS.inBox, value: "in_box_display_only" }] : [], ...id === "credit" ? [{ ...CREDIT_OFFER_TERMS }] : []];
  }
  function attributeRepair(line) {
    if (!["studio-v4", hashSource].includes(valueOf(line.attributes, MANAGED_MARKERS.source))) return { attributes: null };
    let next = line.attributes.map((a) => ({ ...a }));
    if (["cover", "divider"].includes(line.benefitId)) {
      const current = valueOf(next, MANAGED_MARKERS.inBox);
      if (current !== null && current !== "in_box_display_only") return { error: "private_fulfillment_marker_conflict" };
      next = next.filter((a) => !(a.key === "in_box_display_only" && a.value === "true"));
      if (current === null) next.push({ key: MANAGED_MARKERS.inBox, value: "in_box_display_only" });
    }
    if (line.benefitId === "credit") {
      const current = valueOf(next, CREDIT_OFFER_TERMS.key);
      if (current !== null && current !== CREDIT_OFFER_TERMS.value) return { error: "credit_offer_terms_conflict" };
      if (current === null) next.push({ ...CREDIT_OFFER_TERMS });
    }
    return { attributes: JSON.stringify(next) === JSON.stringify(line.attributes) ? null : next };
  }
  function base(reason, warnings, dependencyKey) {
    return { status: "noop", change: null, ajaxChange: null, reason, warnings, dependencyKey, sourceVersion: SOURCE_VERSION, sourceHash: SOURCE_HASH, executesWrites: false };
  }
  function planNativeBenefitSync({ result, lines, managedBenefitVariants, reviewGate, deferAdds = false } = {}) {
    if (reviewGate !== true) return base("review_gate_disabled", [], "review_gate_disabled");
    const normalized = normalizeNativeCartLines(lines), index = mappingIndex(managedBenefitVariants);
    const warnings = [...normalized.warnings, ...index.warnings];
    const fingerprint = JSON.stringify(normalized.lines.map((l) => [l.id, l.productId, l.variantId, l.quantity, l.amount ?? null, l.attributes.map((a) => [a.key, a.value]).sort((a, b) => compare(a[0], b[0]) || compare(a[1], b[1]))]));
    let desired;
    try {
      desired = desiredFrom(result ?? {});
    } catch {
      return { ...base("evaluation_invalid", warnings, fingerprint), status: "blocked" };
    }
    const dependencyKey = JSON.stringify({ attributeSchemaVersion: 2, deferAdds: deferAdds === true, sourceHash: SOURCE_HASH, cart: fingerprint, desired: [...desired], mapping: [...index.current].map(([id, m]) => [id, m.variantId, m.productId, m.verified, m.availableForSale, m.imageUrl, m.imageVerified, m.price, m.requiresShipping, m.inventoryTracked, m.retiredVariantIds ?? []]).sort((a, b) => compare(a[0], b[0])) });
    const blocked = (reason, extra) => ({ ...base(reason, extra ? [...warnings, extra] : warnings, dependencyKey), status: "blocked" });
    if (!normalized.valid) return blocked("cart_snapshot_invalid");
    if (!index.valid) return blocked("managed_mapping_invalid");
    if (!result || result.enabled !== true || result.sourceVersion !== SOURCE_VERSION || result.sourceHash !== SOURCE_HASH) return blocked("evaluation_source_not_current");
    const owned = [];
    for (const line of normalized.lines) {
      const marker = valueOf(line.attributes, MANAGED_MARKERS.display);
      if (marker === "__CONFLICT__") return blocked("management_marker_conflict", { code: "management_marker_conflict", lineId: line.id });
      if (marker !== "true") continue;
      const mapped = index.all.get(line.variantId);
      if (!mapped) return blocked("marked_variant_not_in_exact_managed_mapping", { code: "marked_variant_unknown", lineId: line.id });
      const declared = valueOf(line.attributes, MANAGED_MARKERS.benefit);
      if (declared !== null && declared !== mapped.benefitId) return blocked("managed_benefit_identity_conflict", { code: "managed_benefit_identity_conflict", lineId: line.id });
      if (mapped.productId && mapped.productId !== line.productId && !mapped.retired) return blocked("managed_product_identity_conflict", { code: "managed_product_identity_conflict", lineId: line.id });
      if (!zeroPrice(line.amount)) return blocked("managed_line_not_verified_zero_price", { code: "managed_line_not_verified_zero_price", lineId: line.id });
      owned.push({ ...line, benefitId: mapped.benefitId, retired: mapped.retired });
    }
    const ownedIds = new Set(owned.map((l) => l.id));
    const fresh = evaluateCheckoutBenefits({ lines: normalized.lines.filter((l) => !ownedIds.has(l.id)).map((l) => l.evaluationLine), settings: { review_enabled: true } });
    warnings.push(...fresh.warnings);
    if (resultSignature(result) !== resultSignature(fresh)) return blocked("stale_evaluation");
    const repairs = /* @__PURE__ */ new Map();
    for (const line of owned) {
      const repair = attributeRepair(line);
      if (repair.error) return blocked(repair.error, { code: repair.error, lineId: line.id });
      if (repair.attributes) repairs.set(line.id, repair.attributes);
    }
    const operation = (kind, line, id, quantity, reason, nextAttributes) => {
      const mapping = index.current.get(id), attrs = kind === "add" ? newAttributes(id) : void 0;
      let change, ajaxChange;
      if (kind === "remove") {
        change = { type: "removeCartLine", id: line.id, quantity: line.quantity };
        ajaxChange = line.kind === "ajax" ? { endpoint: "/cart/change.js", body: { id: line.id, quantity: 0 } } : null;
      }
      if (kind === "update") {
        change = { type: "updateCartLine", id: line.id, ...quantity !== void 0 ? { quantity } : {}, ...nextAttributes ? { attributes: nextAttributes } : {} };
        ajaxChange = line.kind === "ajax" ? { endpoint: "/cart/change.js", body: { id: line.id, ...quantity !== void 0 ? { quantity } : nextAttributes ? { quantity: line.quantity } : {}, ...nextAttributes ? { properties: Object.fromEntries(nextAttributes.map((a) => [a.key, a.value])) } : {} } } : null;
      }
      if (kind === "add") {
        change = { type: "addCartLine", merchandiseId: mapping.variantId, quantity, attributes: attrs };
        ajaxChange = { endpoint: "/cart/add.js", body: { items: [{ id: mapping.variantId.slice(VARIANT.length), quantity, properties: Object.fromEntries(attrs.map((a) => [a.key, a.value])) }] } };
      }
      return { ...base(reason, warnings, dependencyKey), status: "change", change, ajaxChange, benefitId: id, expectedCartFingerprint: fingerprint };
    };
    for (const id of ORDER) {
      const quantity = desired.get(id) ?? 0;
      const rows = owned.filter((l) => l.benefitId === id).sort((a, b) => Number(b.quantity === quantity) - Number(a.quantity === quantity) || compare(a.id, b.id));
      const retired = rows.filter((l) => l.retired);
      if (retired.length) return operation("remove", retired[0], id, 0, "retired_managed_variant");
      if (quantity === 0 && rows.length) return operation("remove", rows[0], id, 0, "orphan_managed_benefit");
      if (rows.length > 1) return operation("remove", rows[1], id, 0, "duplicate_managed_benefit");
    }
    for (const id of ORDER) {
      const row = owned.find((l) => l.benefitId === id && !l.retired && repairs.has(l.id));
      if (row) return operation("update", row, id, void 0, "managed_attributes_migrated", repairs.get(row.id));
    }
    for (const id of ORDER) if (desired.has(id)) {
      const problem = metadataProblem(index.current.get(id));
      if (problem) return blocked(problem, { code: problem, benefitId: id });
    }
    let additionsDeferred = false;
    for (const id of ORDER) {
      const quantity = desired.get(id);
      if (!quantity) continue;
      const row = owned.find((l) => l.benefitId === id && !l.retired);
      if (row && row.quantity !== quantity) return operation("update", row, id, quantity, "managed_quantity_changed");
      if (!row) {
        if (deferAdds === true) {
          additionsDeferred = true;
          continue;
        }
        return operation("add", null, id, quantity, "managed_benefit_missing");
      }
    }
    return base(additionsDeferred ? "checkout_additions_deferred" : "native_benefits_in_sync", warnings, dependencyKey);
  }

  // untracked/checkout-studio-integration-20261029/native-sync/theme-adapter.mjs
  function createStorefrontBenefitSync({ readCart, applyAjaxChange, onStatus, onChanged, deferAdds = false, managedBenefitVariants = native_display_map_default.benefits } = {}) {
    if (typeof readCart !== "function" || typeof applyAjaxChange !== "function") throw new TypeError("cart transports required");
    let inFlight = null;
    const observe = (fn, value) => {
      try {
        Promise.resolve(fn?.(value)).catch(() => {
        });
      } catch {
      }
    };
    function sync({ reviewGate = false } = {}) {
      if (reviewGate !== true) return Promise.resolve({ status: "disabled", reason: "review_gate_disabled", mutations: 0 });
      if (inFlight) return inFlight;
      inFlight = Promise.resolve().then(async () => {
        let mutations = 0, previousDependency = null, lastCart = null;
        const finish = (status, reason, extra = {}) => {
          const outcome = { status, reason, mutations, ...extra };
          observe(onStatus, outcome);
          if (mutations > 0) observe(onChanged, { ...outcome, cart: lastCart });
          return outcome;
        };
        observe(onStatus, { status: "syncing", mutations: 0 });
        for (; ; ) {
          try {
            lastCart = await readCart();
          } catch {
            return finish("blocked", "cart_read_failed");
          }
          const normalized = normalizeNativeCartLines(lastCart);
          const result = evaluateCheckoutBenefits({ lines: normalized.lines.map((line) => line.evaluationLine), settings: { review_enabled: true } });
          const plan = planNativeBenefitSync({ result, lines: lastCart, managedBenefitVariants, reviewGate: true, deferAdds: deferAdds === true });
          if (plan.status === "blocked") return finish("blocked", plan.reason, { warnings: plan.warnings });
          if (plan.status === "noop") return finish(plan.reason === "checkout_additions_deferred" ? "prepared" : "synced", plan.reason, { warnings: plan.warnings });
          if (!plan.ajaxChange) return finish("blocked", "ajax_change_missing");
          if (plan.dependencyKey === previousDependency) return finish("blocked", "cart_did_not_change");
          if (mutations >= 32) return finish("blocked", "mutation_limit_reached");
          let response;
          try {
            response = await applyAjaxChange(plan.ajaxChange);
          } catch {
            return finish("blocked", "cart_write_failed");
          }
          if (response?.ok !== true) return finish("blocked", "cart_write_rejected");
          mutations++;
          previousDependency = plan.dependencyKey;
        }
      }).finally(() => {
        inFlight = null;
      });
      return inFlight;
    }
    return Object.freeze({ sync, get pending() {
      return inFlight !== null;
    } });
  }
  var REVIEW_THEME_ID = "160325730459";
  var NATIVE_BENEFIT_THEME_IDS = Object.freeze(["159621873819", REVIEW_THEME_ID]);
  function nativeBenefitThemeAllowed(id) { return NATIVE_BENEFIT_THEME_IDS.includes(String(id)); }
  var REVIEW_SCRIPT_ID = "luggex-native-benefit-review";
  var OWN_SOURCE = "luggex-native-benefit-review";
  function installStorefrontBenefitSync({ window: win = globalThis.window, scriptElement, onStatus, deferAdds = false } = {}) {
    const doc = win?.document;
    const script = scriptElement ?? doc?.getElementById(REVIEW_SCRIPT_ID);
    const enabled = () => nativeBenefitThemeAllowed(win?.Shopify?.theme?.id) && script?.id === REVIEW_SCRIPT_ID && script?.dataset?.enabled === "true";
    if (!enabled()) return { installed: false, reason: "review_gate_disabled" };
    const pubsub = win.theme?.pubsub, eventName = pubsub?.PUB_SUB_EVENTS?.cartUpdate;
    if (!eventName || typeof pubsub.subscribe !== "function" || typeof pubsub.publish !== "function") return { installed: false, reason: "theme_pubsub_unavailable" };
    const root = win.Shopify?.routes?.root;
    if (typeof root !== "string" || !root.startsWith("/") || root.startsWith("//")) return { installed: false, reason: "localized_routes_unavailable" };
    const route = (endpoint) => {
      const url = new URL(root.replace(/\/$/, "") + endpoint, win.location.origin);
      if (url.origin !== win.location.origin) throw Error("cross_origin_route");
      return url;
    };
    let destroyed = false, refresh = Promise.resolve();
    const notify = (value) => {
      try {
        Promise.resolve(onStatus?.(value)).catch(() => {
        });
      } catch {
      }
    };
    const fetchJson = async (url, options = {}) => {
      const response = await win.fetch(url, { credentials: "same-origin", ...options });
      const data = await response.json();
      if (!response.ok || data?.errors || data?.status) throw Error("shopify_request_rejected");
      return data;
    };
    const collectSections = () => {
      const sections = [...doc.querySelectorAll("cart-items[data-section-id]")].map((el) => el.getAttribute("data-section-id"));
      doc.documentElement.dispatchEvent(new win.CustomEvent("cart:bundled-sections", { bubbles: true, detail: { sections } }));
      return [...new Set(sections.filter((id) => typeof id === "string" && id))];
    };
    const refreshSections = async () => {
      if (destroyed || !enabled()) return;
      const ids = collectSections(), sections = {};
      for (let i = 0; i < ids.length; i += 5) {
        const url = new URL(win.location.pathname, win.location.origin);
        url.searchParams.set("sections", ids.slice(i, i + 5).join(","));
        Object.assign(sections, await fetchJson(url));
      }
      if (ids.some((id) => typeof sections[id] !== "string")) throw Error("cart_sections_missing");
      const cart = await fetchJson(route("/cart.js"), { cache: "no-store" });
      if (!destroyed && enabled()) pubsub.publish(eventName, { source: OWN_SOURCE, cart: { ...cart, sections } });
    };
    const controller = createStorefrontBenefitSync({
      deferAdds,
      readCart: () => {
        if (destroyed || !enabled()) throw Error("review_gate_disabled");
        return fetchJson(route("/cart.js"), { cache: "no-store" });
      },
      applyAjaxChange: async (change) => {
        if (destroyed || !enabled()) return { ok: false };
        await fetchJson(route(change.endpoint), { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(change.body) });
        return { ok: true };
      },
      onStatus: notify,
      onChanged: () => {
        refresh = refresh.then(refreshSections).catch(() => notify({ status: "blocked", reason: "cart_section_refresh_failed" }));
      }
    });
    const sync = () => controller.sync({ reviewGate: !destroyed && enabled() });
    const unsubscribe = pubsub.subscribe(eventName, (event) => {
      if (event?.source !== OWN_SOURCE) void sync();
    });
    const ready = sync();
    return { installed: true, ready, sync, get refreshed() {
      return refresh;
    }, destroy() {
      destroyed = true;
      if (typeof unsubscribe === "function") unsubscribe();
    } };
  }

  // untracked/checkout-studio-integration-20261029/theme-native/assets/luggex-native-benefit-review.entry.mjs
  function bootstrapNativeBenefitReview(win = window) {
    const script = win.document.getElementById(REVIEW_SCRIPT_ID);
    if (!nativeBenefitThemeAllowed(win.Shopify?.theme?.id) || script?.dataset?.enabled !== "true") return null;
    if (win.__luggexNativeBenefitReview) return win.__luggexNativeBenefitReview;
    let installation, lastOutcome = { status: "initializing" };
    const ready = new Promise((resolve) => {
      const start = () => {
        installation = installStorefrontBenefitSync({ window: win, scriptElement: script, deferAdds: true, onStatus: (outcome) => {
          lastOutcome = outcome;
          win.document.dispatchEvent(new win.CustomEvent("luggex:native-benefits-status", { detail: outcome }));
        } });
        if (!installation.installed) {
          lastOutcome = { status: "blocked", reason: installation.reason };
          resolve(lastOutcome);
          return;
        }
        installation.ready.then(resolve);
      };
      if (win.document.readyState === "loading") win.document.addEventListener("DOMContentLoaded", start, { once: true });
      else start();
    });
    const api = {
      ready,
      async sync() {
        await ready;
        if (!installation?.installed) return lastOutcome;
        return installation.sync();
      },
      async refreshed() {
        await ready;
        if (installation?.installed) await installation.refreshed;
      },
      get status() {
        return lastOutcome;
      }
    };
    win.__luggexNativeBenefitReview = api;
    return api;
  }
  if (typeof window !== "undefined") bootstrapNativeBenefitReview(window);
})();
